import 'rxjs/add/operator/map';

import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';

@Directive({
    selector: `[showDropDown]`
})

// Use this directive for Auto Complete Field. It will display dropdown List of all values when click on that field
export class ShowDropdownDirective implements AfterViewInit {
    @Input('showDropDown') data: any;
    control: any;
    records: any;
    constructor(private utility: Utility, private sharedService: SharedService, private elRef: ElementRef) {
    }

    ngAfterViewInit(): void {
        this.control = this.elRef.nativeElement.getAttribute('formControlname');
    }

    @HostListener('click', ['$event'])
    click(event) {
        let scope = this.data.scope;
        let formAttr = this.data.formAttr || 'form';
        let control = scope[formAttr].get(this.control);
        if (control.value) {
            let subject = scope[this.data.model + 'valueUpdated'];
            this.records = subject;

            if (this.records) {
                scope[this.data.model + "FilteredOptions"] = control.valueChanges
                    .debounceTime(50)
                    .distinctUntilChanged()
                    .startWith(null)
                    .map(i => i && i === 'object' ? i.name : i)
                    .map(name => name ? this.utility.filterItems(this.records, name) : this.records.slice());
            }
        }

    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/show-dropdown.directive.ts